module.exports = __webpack_public_path__ + "img/20190821144955QQ截图20190821130644.16f3e0ed.png";